import Alpine from "alpinejs";

Alpine.data("gallery", (media) => ({
  media: media,

  get hasTrack() {
    return this.media.length > 1;
  },

  init() {
    this.media = this.media
      .sort((a, b) => a.position - b.position)
      .map((item, index) => {
        item.active = index === 0;
        item.src.src = `${item.preview_image.src}&width=800`;
        item.preview_image.src = `${item.preview_image.src}&width=200`;
        return item;
      });
  },
  setActiveFromVariant() {
    let variant = this.$event.detail;

    this.setActive(
      this.media.findIndex((item) => item.id === variant.featured_media.id),
    );
  },
  setActive(activeIndex) {
    this.media = this.media.map((item, index) => {
      item.active = index === activeIndex;
      return item;
    });

    if (activeIndex === 0) {
      this.$refs.track.scrollTo({
        left: 0,
        behavior: "smooth",
      });

      return;
    }

    this.$refs.track.children[activeIndex].scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "center",
    });
  },
  close() {
    this.$root.close();
  },
  previousImage() {
    let currentIndex = this.media.findIndex((item) => item.active);
    let previousIndex =
      (currentIndex - 1 + this.media.length) % this.media.length;
    this.setActive(previousIndex);
  },
  nextImage() {
    let currentIndex = this.media.findIndex((item) => item.active);
    let nextIndex = (currentIndex + 1) % this.media.length;
    this.setActive(nextIndex);
  },
}));
